import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

interface TokenResponse {
  token: string;
}

@Injectable({ providedIn: 'root' })

export class PresignService {
  
  private TOKEN_URL = environment.apiTokenPresignUrl;
  private PRESIGN_URL = environment.apiPresignUrl;
  private UPLOAD_STATUS_URL = environment.apiPresignURlUploadStatus;

  private token: string | null = null;
  private tokenExpiration: number | null = null;

  constructor(private http: HttpClient) {}

  async getToken(): Promise<string> {
    const now = Date.now();

    if (this.token && this.tokenExpiration && now < this.tokenExpiration) {
      return this.token;
    }

    const body = {
      user_id: '1',
      name: 'PortalProvedores_PVR'
    };

    const response$ = this.http.post<TokenResponse>(this.TOKEN_URL, body);
    const response = await lastValueFrom(response$);

    this.token = response.token;
    this.tokenExpiration = now + (4 * 60 * 1000);
    return this.token;
  }

  async getPresignedUrl(folder: string, filename: string, bucket: string): Promise<{uploadUrl: string; idProcesamiento: string}> {
    const token = await this.getToken();

    const headers = new HttpHeaders({Authorization: `Bearer ${token}`});

    const body = {
      folder_name: folder,
      file_name: filename,
      bucket_name: bucket
    };

    const response$ = this.http.post<{upload_url: string; id_procesamiento: string}>(this.PRESIGN_URL, body, { headers });
    const response = await lastValueFrom(response$);
  
    return{ uploadUrl: response.upload_url, idProcesamiento: response.id_procesamiento};
  }

  async uploadFileToS3(signedUrl: string, file: File): Promise <void> {
    try{
      const extension = file.name.split('.').pop()?.toLowerCase();
      const contentType = extension === 'pdf' ? 'application/pdf' : extension === 'xml' ? 'application/xml' : extension === 'xls' ? 'application/vnd.ms-excel' : extension === 'xlsx' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/octet-stream';
      const headers = new HttpHeaders({'Content-Type': contentType});

      const response$ = this.http.put(signedUrl, file, { headers });
      await lastValueFrom(response$);
      
    } catch ( error ){
      console.error('Error al subir el archivo')
    }
  }

  async uploadStatus(processId: string): Promise<any>{
    const token = await this.getToken();
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });

    const statusUrl = `${this.UPLOAD_STATUS_URL}/${processId}`;

    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        try {
          const response$ = this.http.get<any>(statusUrl, {headers});
          const response = await lastValueFrom(response$);

          const status = response.status;

          if (status === 'ERROR') {
            clearInterval(interval);
            reject(response);

          } else if (status === 'COMPLETED') {
            clearInterval(interval);
            reject(response);
          }

        } catch (error) {
            clearInterval(interval);
            reject(error);
        }
      }, 2000);
    })

  }

  clearToken() {
    this.token = null;
    this.tokenExpiration = null;
  }
}
